<app-test-env-banner *ngIf="isTestEnv"></app-test-env-banner>
<app-main-sidenav [containsBanner]="isTestEnv">
    <router-outlet></router-outlet>
</app-main-sidenav>
